import { defineComponent as N, ref as G, computed as i, onMounted as D, onUnmounted as Q, toRaw as g, provide as X, watch as x, h as B, Fragment as I, inject as Y, resolveComponent as _, createBlock as w, openBlock as O, withCtx as A, createCommentVNode as Z, createElementBlock as ee, createTextVNode as ae, toDisplayString as C, renderList as te, createElementVNode as P } from "vue";
import { t as K, o as E, H, K as oe, T as re, a as y } from "./dom-B5R6OWVp.js";
import { O as le, m as T, P as F, N as $, T as j } from "./focus-management-uTsAyIu4.js";
import { E as ne, T as ue, K as U, M } from "./label-DS73oEMG.js";
import { p as ie } from "./use-tree-walker-AStIFPaK.js";
import { d as de, e as pe, f as se, a as ce, p as ve } from "./use-controllable-BEb0o1U6.js";
import { _ as me } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function fe(e, n) {
  return e === n;
}
let W = Symbol("RadioGroupContext");
function J(e) {
  let n = Y(W, null);
  if (n === null) {
    let p = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(p, J), p;
  }
  return n;
}
let be = N({ name: "RadioGroup", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => fe }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-radiogroup-${K()}` } }, inheritAttrs: !1, setup(e, { emit: n, attrs: p, slots: s, expose: c }) {
  let v = G(null), l = G([]), f = U({ name: "RadioGroupLabel" }), h = M({ name: "RadioGroupDescription" });
  c({ el: v, $el: v });
  let [u, S] = de(i(() => e.modelValue), (a) => n("update:modelValue", a), i(() => e.defaultValue)), m = { options: l, value: u, disabled: i(() => e.disabled), firstOption: i(() => l.value.find((a) => !a.propsRef.disabled)), containsCheckedOption: i(() => l.value.some((a) => m.compare(g(a.propsRef.value), g(e.modelValue)))), compare(a, o) {
    if (typeof e.by == "string") {
      let t = e.by;
      return (a == null ? void 0 : a[t]) === (o == null ? void 0 : o[t]);
    }
    return e.by(a, o);
  }, change(a) {
    var o;
    if (e.disabled || m.compare(g(u.value), g(a))) return !1;
    let t = (o = l.value.find((d) => m.compare(g(d.propsRef.value), g(a)))) == null ? void 0 : o.propsRef;
    return t != null && t.disabled ? !1 : (S(a), !0);
  }, registerOption(a) {
    l.value.push(a), l.value = le(l.value, (o) => o.element);
  }, unregisterOption(a) {
    let o = l.value.findIndex((t) => t.id === a);
    o !== -1 && l.value.splice(o, 1);
  } };
  X(W, m), ie({ container: i(() => E(v)), accept(a) {
    return a.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : a.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(a) {
    a.setAttribute("role", "none");
  } });
  function b(a) {
    if (!v.value || !v.value.contains(a.target)) return;
    let o = l.value.filter((t) => t.propsRef.disabled === !1).map((t) => t.element);
    switch (a.key) {
      case y.Enter:
        ve(a.currentTarget);
        break;
      case y.ArrowLeft:
      case y.ArrowUp:
        if (a.preventDefault(), a.stopPropagation(), F(o, $.Previous | $.WrapAround) === j.Success) {
          let t = l.value.find((d) => {
            var r;
            return d.element === ((r = T(v)) == null ? void 0 : r.activeElement);
          });
          t && m.change(t.propsRef.value);
        }
        break;
      case y.ArrowRight:
      case y.ArrowDown:
        if (a.preventDefault(), a.stopPropagation(), F(o, $.Next | $.WrapAround) === j.Success) {
          let t = l.value.find((d) => {
            var r;
            return d.element === ((r = T(d.element)) == null ? void 0 : r.activeElement);
          });
          t && m.change(t.propsRef.value);
        }
        break;
      case y.Space:
        {
          a.preventDefault(), a.stopPropagation();
          let t = l.value.find((d) => {
            var r;
            return d.element === ((r = T(d.element)) == null ? void 0 : r.activeElement);
          });
          t && m.change(t.propsRef.value);
        }
        break;
    }
  }
  let R = i(() => {
    var a;
    return (a = E(v)) == null ? void 0 : a.closest("form");
  });
  return D(() => {
    x([R], () => {
      if (!R.value || e.defaultValue === void 0) return;
      function a() {
        m.change(e.defaultValue);
      }
      return R.value.addEventListener("reset", a), () => {
        var o;
        (o = R.value) == null || o.removeEventListener("reset", a);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: a, name: o, id: t, form: d, ...r } = e, L = { ref: v, id: t, role: "radiogroup", "aria-labelledby": f.value, "aria-describedby": h.value, onKeydown: b };
    return B(I, [...o != null && u.value != null ? pe({ [o]: u.value }).map(([k, V]) => B(se, oe({ features: ce.Hidden, key: k, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: d, name: k, value: V }))) : [], H({ ourProps: L, theirProps: { ...p, ...re(r, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: p, slots: s, name: "RadioGroup" })]);
  };
} });
var Re = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(Re || {});
let ge = N({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-radiogroup-option-${K()}` } }, setup(e, { attrs: n, slots: p, expose: s }) {
  let c = J("RadioGroupOption"), v = U({ name: "RadioGroupLabel" }), l = M({ name: "RadioGroupDescription" }), f = G(null), h = i(() => ({ value: e.value, disabled: e.disabled })), u = G(1);
  s({ el: f, $el: f });
  let S = i(() => E(f));
  D(() => c.registerOption({ id: e.id, element: S, propsRef: h })), Q(() => c.unregisterOption(e.id));
  let m = i(() => {
    var r;
    return ((r = c.firstOption.value) == null ? void 0 : r.id) === e.id;
  }), b = i(() => c.disabled.value || e.disabled), R = i(() => c.compare(g(c.value.value), g(e.value))), a = i(() => b.value ? -1 : R.value || !c.containsCheckedOption.value && m.value ? 0 : -1);
  function o() {
    var r;
    c.change(e.value) && (u.value |= 2, (r = E(f)) == null || r.focus());
  }
  function t() {
    u.value |= 2;
  }
  function d() {
    u.value &= -3;
  }
  return () => {
    let { id: r, value: L, disabled: k, ...V } = e, q = { checked: R.value, disabled: b.value, active: !!(u.value & 2) }, z = { id: r, ref: f, role: "radio", "aria-checked": R.value ? "true" : "false", "aria-labelledby": v.value, "aria-describedby": l.value, "aria-disabled": b.value ? !0 : void 0, tabIndex: a.value, onClick: b.value ? void 0 : o, onFocus: b.value ? void 0 : t, onBlur: b.value ? void 0 : d };
    return H({ ourProps: z, theirProps: V, slot: q, attrs: n, slots: p, name: "RadioGroupOption" });
  };
} }), ye = ue, he = ne;
const Se = N({
  name: "t-radio",
  components: { RadioGroup: be, RadioGroupOption: ge, RadioGroupLabel: ye, RadioGroupDescription: he },
  props: {
    modelValue: [Object, String, Boolean, Number],
    options: [Array, Function],
    label: String
  },
  setup(e, { emit: n }) {
    const p = G([]);
    return x(() => e.options, async (s) => {
      p.value = typeof s == "function" ? await s() : s || [];
    }, { immediate: !0 }), {
      opts: p,
      model: i({
        get() {
          return e.modelValue;
        },
        set(s) {
          n("update:model-value", s), n("change", s);
        }
      })
    };
  }
}), Ge = ["checked"], Oe = { class: "tt-pl-2 tt-cursor-pointer" };
function $e(e, n, p, s, c, v) {
  const l = _("RadioGroupLabel"), f = _("RadioGroupOption"), h = _("RadioGroup");
  return O(), w(h, {
    modelValue: e.model,
    "onUpdate:modelValue": n[0] || (n[0] = (u) => e.model = u)
  }, {
    default: A(() => [
      e.$props.label ? (O(), w(l, { key: 0 }, {
        default: A(() => [
          ae(C(e.$props.label), 1)
        ]),
        _: 1
      })) : Z("", !0),
      (O(!0), ee(I, null, te(e.opts, (u) => (O(), w(f, {
        as: "span",
        value: u,
        class: "tt-pl-2 tt-cursor-pointer"
      }, {
        default: A(({ checked: S }) => [
          P("input", {
            type: "radio",
            checked: S,
            class: "tt-cursor-pointer"
          }, null, 8, Ge),
          P("label", Oe, C(u), 1)
        ]),
        _: 2
      }, 1032, ["value"]))), 256))
    ]),
    _: 1
  }, 8, ["modelValue"]);
}
const Ne = /* @__PURE__ */ me(Se, [["render", $e]]);
export {
  Ne as default
};
//# sourceMappingURL=Radio-BohqdGUL.js.map
